module.exports = {
  async getPlaceDestinations(placeId, params) {
    const url = `${this.url}/${this.version}/places/${placeId}/destinations`;
    const response = await this.get(url, params, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/place_destination_api.js